import Marionette from 'backbone.marionette';
import legislativeDayControlItemviewTmpl from '../templates/legislative_day_control_itemview.tpl';
export default Marionette.ItemView.extend({
  template: legislativeDayControlItemviewTmpl
  // tagName: "span",
  // className: "day-item"
});